import { render, staticRenderFns } from "./ListEncaminhamentos.vue?vue&type=template&id=2fee43cb"
import script from "./ListEncaminhamentos.vue?vue&type=script&lang=js"
export * from "./ListEncaminhamentos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports